import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import RichTextEditor from 'react-rte';
import OutlinedFormControl from './OutlinedFormControl';

interface IBeaconRte {
  required?: boolean;
  label?: string;
  error?: boolean;
  style?: React.CSSProperties;
  value?: any;

  onChange?: (x: any) => void;
  onBlur?: (hasText: boolean) => void;
}

const useStyles = makeStyles({
  editor: {
    border: 0,
  },
});

const htmlOptions = {
  entityStyleFn: (entity: any) => {
    const entityType = entity.get('type').toLowerCase();
    const urlRegEx = new RegExp('^(http|https)://', 'i');

    // Make sure URLs have http or https
    if (entityType === 'link') {
      const data = entity.getData();
      if (!urlRegEx.test(data.url)) {
        return {
          element: 'a',
          attributes: {
            href: `//${data.url}`,
            target: '_blank',
            rel: 'noopener noreferrer',
          },
          ...data,
        };
      } else {
        return {
          element: 'a',
          attributes: {
            href: data.url,
            target: '_blank',
            rel: 'noopener noreferrer',
          },
          ...data,
        };
      }
    }
  },
};

const toolbarConfig = {
  display: ['INLINE_STYLE_BUTTONS', 'LINK_BUTTONS'],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD' },
    { label: 'Italic', style: 'ITALIC' },
    { label: 'Underline', style: 'UNDERLINE' },
  ],
};

const BeaconRte = (props: IBeaconRte) => {
  const classes = useStyles();
  const [isActive, setIsActive] = useState(false);

  return (
    <OutlinedFormControl
      label={props.label}
      style={{ ...props.style, ...{ width: '100%' } }}
      required={props.required}
      error={props.error !== undefined ? props.error : undefined}
      // isActive={isActive}
    >
      <RichTextEditor
        value={props.value}
        placeholder={props.label ? `Enter a ${props.label}` : undefined}
        onChange={props.onChange ? props.onChange : undefined}
        className={classes.editor}
        toolbarConfig={toolbarConfig}
        // onBlur={() => {
        //   setIsActive(false);
        // }}
        // onFocus={() => {
        //   setIsActive(true);
        // }}
        editorStyle={{
          height: '150px',
          border: 0,
          overflowY: 'scroll',
          fontFamily: [
            '"Open Sans"',
            'Helvetica',
            'Arial',
            '"sans - serif"',
          ].join(','),
        }}
      />
    </OutlinedFormControl>
  );
};

export const convertBeaconRteToHtml = (content: any): string => {
  if (!content) return '';
  return content.toString('html', htmlOptions);
};

export function EmptyRteValue() {
  return RichTextEditor.createEmptyValue();
}

export function EditorValueHasText(value: any): boolean {
  return value.getEditorState().getCurrentContent().hasText();
}

export function HtmlToBeaconRte(html: string) {
  return RichTextEditor.createValueFromString(html, 'html');
}

export default BeaconRte;
